var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside",
        },
      ],
      staticClass: "modules-content",
    },
    [
      _c("div", { staticClass: "modules-content-head" }, [
        _c(
          "div",
          { staticClass: "modules-content-head-title" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("modules.modules")) +
                "\n            "
            ),
            _c("a-icon", {
              staticClass: "settings-icon",
              attrs: { type: "setting" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.gotoModuleSettings.apply(null, arguments)
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modules-content-body" },
        _vm._l(_vm.modules, function (module) {
          return _c(
            "div",
            {
              key: module._id,
              staticClass: "modules-content-item",
              on: {
                click: function ($event) {
                  return _vm.gotoModule(module)
                },
              },
            },
            [
              _c("div", { staticClass: "modules-content-item-icon" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(module.icon || "extension")),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: module.displayName },
                      expression: "{ content: module.displayName }",
                    },
                  ],
                  staticClass: "modules-content-item-title",
                },
                [
                  _c("span", { staticClass: "ellipsis" }, [
                    _vm._v(_vm._s(module.displayName)),
                  ]),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }